import {isNullOrUndefined} from "../../../../../common/utils";
import {Operators} from "../../../../../components/condition/model/Operators";
import {findConditionById} from "../../../../../components/condition/utils/findConditionById";
import {
  disjunctionTransitionsForKeyConditions
} from "../../../../../components/condition/utils/transitions/transitionsForKeyConditions";
import {KeyConditionAction} from "../../model";

const patchOperationConstants = {
  add: "ADD",
  remove: "REMOVE",
  replace: "REPLACE",
};

export function patchApiCallAttributes(
  action,
  mainCondition,
  editedCondition,
  conditionIdToBeEdited,
  excludedMembers,
) {
  let patchOperation;
  let pathFromRoot;
  let newCondition = editedCondition;
  switch (action) {
    case KeyConditionAction.ADD: {
      pathFromRoot = mainCondition.pathFromRoot;
      if (mainCondition.operator === Operators.logicalOR) {
        patchOperation = patchOperationConstants.add;
      } else {
        patchOperation = patchOperationConstants.replace;
        if (mainCondition.operator !== Operators.noConditionNull) {
          newCondition = disjunctionTransitionsForKeyConditions(mainCondition, newCondition);
        }
      }
      break;
    }
    case KeyConditionAction.EDIT: {
      patchOperation = patchOperationConstants.replace;
      const nodeToBeEdited = findConditionById(mainCondition, conditionIdToBeEdited);
      pathFromRoot = nodeToBeEdited.pathFromRoot;
      break;
    }
    case KeyConditionAction.DELETE: {
      patchOperation = patchOperationConstants.remove;
      const nodeToBeDeleted = findConditionById(mainCondition, conditionIdToBeEdited);
      pathFromRoot = nodeToBeDeleted.pathFromRoot;
      newCondition = undefined;
      break;
    }
    default: {
    }
  }
  newCondition = newCondition?.toJSON(true);
  const patchApiPayload = {patchOperation, pathFromRoot, excludedMembers};
  if (!isNullOrUndefined(newCondition)) {
    patchApiPayload.newCondition = newCondition;
  }
  return patchApiPayload;
}
